/* eslint max-len:0 */
export const YT_VIDEOS = ['mjTX-uMcA7c', 'E15mFIPERx0', 'AigL5eRfsN4', 'o3gRkS8AgJc', 'zRDQR3vqTiA', '351htUIggzs', 'eMAdOQz5LL0', 'DBL4q-Wh-f4', 'mGNrXNeBxPM']
export const SOCIAL = ['facebook', 'twitter', 'youtube']
export const LINK_FACEBOOK = 'facebook.com/Padraig-Lynch-1424933647621079'
export const LINK_TWITTER = 'twitter.com/PLynchMedia'
export const LINK_YOUTUBE = 'youtube.com/channel/UCwIAbhKrTNQ29YWN-jca3bg'
export const SOCIAL_LINKS = [LINK_FACEBOOK, LINK_TWITTER, LINK_YOUTUBE]
